export const adminDashboard = {
  teacher: "Teacher",
  teachers: "Teachers",
  createTeacher: "Create Teacher",
  addTeacher: "Add Teacher",
  createTeacherDescription:
    "Add a new teacher to your school by filling in their details below.",
  teacherCreated: "Teacher created successfully",
  backToTeachers: "Back to Teachers",
  admin: "Admin",
  dashboard: "Dashboard",
  adminDashboard: "Admin Dashboard",
  teacherUsage: "Teacher Usage",
  studentUsage: "Student Usage",
  lastUpdated: "Updated {{date}}",
  refreshInterval: "Refreshes every 10 minutes",
  comparedWith: "Compared with <Range>{{range}}</Range>",
  comparedWithInfo:
    "Every ↑ / ↓ trend on this tab compares the selected period with this prior period.",
  aboutComparedWith: "About the comparison period",
  sectionSelectedPeriod: "Selected period",
  sectionComparedWith: "Compared with",
  description_teachers:
    "See how teachers are using ClassBank. Sort by activity, positivity, or transactions to see who might need support.",
  description_students:
    "See how students are doing across the school. Filter by class or search by name to find students who may need support.",
  overview: "Overview",
  students: "Students",
  timeSpan: "Time span",
  preset_1w: "1 week",
  preset_1m: "1 month",
  preset_3m: "3 months",
  preset_6m: "6 months",
  preset_school_year: "School year",
  custom: "Custom",
  pickDates: "Pick dates",
  customTimeSpan: "Custom time span",
  dateFrom: "Date from",
  dateTo: "Date to",
  apply: "Apply",
  customRangeError_missingDate: "Pick both dates",
  customRangeError_fromAfterTo: "Start date must be before end date",
  customRangeError_futureDate: "End date can't be in the future",
  customRangeError_rangeTooLong: "Range can't exceed 24 months",
  positivityRatio: "Positivity Ratio",
  attendanceRatio: "Attendance Ratio",
  totalTransactions: "Total Transactions",
  totalEarned: "Total Earned",
  activeTeachers: "Active Teachers",
  activeStudents: "Active Students",
  teachersUsingClassBank: "active teachers on ClassBank",
  kpiTitleTeachers: "Teachers",
  kpiTitleActivity: "Activity",
  kpiTitleTransactions: "Transactions",
  kpiTitleWithoutBonus: "Without a bonus",
  allTeachers: "All teachers",
  allTeachersQuestion:
    "How is each teacher using ClassBank? Sort by Positivity or Last Active to determine who needs support.",
  allTeachersTable: "All teachers table",
  noTeachersYet: "No teachers in your school yet.",
  searchTeacher: "Search teacher...",
  showingTeachers: "Showing {{from}}–{{to}} of {{total}} teachers",
  column_teacher: "Teacher",
  column_positivity: "Positivity",
  column_total: "Total",
  column_bonus: "Bonus",
  column_fine: "Fine",
  column_attendance: "Attendance",
  column_salary: "Salary",
  column_expense: "Expense",
  column_lastActive: "Last active",
  lastActiveNever: "Never active",
  aboutColumn: "About {{column}}",
  lastActiveInfo: "The last time this teacher signed in to ClassBank.",
  totalInfo: "Net of all transactions in the selected period.",
  attendanceNotConnectedCell: "Attendance integration not connected",
  attendanceNoData: "No attendance data",
  countTrendMore_bonus_one: "{{formatted}} more bonus this period",
  countTrendMore_bonus_other: "{{formatted}} more bonuses this period",
  countTrendFewer_bonus_one: "{{formatted}} fewer bonus this period",
  countTrendFewer_bonus_other: "{{formatted}} fewer bonuses this period",
  countTrendMore_fine_one: "{{formatted}} more fine this period",
  countTrendMore_fine_other: "{{formatted}} more fines this period",
  countTrendFewer_fine_one: "{{formatted}} fewer fine this period",
  countTrendFewer_fine_other: "{{formatted}} fewer fines this period",
  studentsNeedAttention: "Students who need attention",
  studentsNeedAttentionQuestion:
    "Students with the fewest bonuses this period, the lowest positivity ratios, the most fines and the lowest attendance.\nEach one is a conversation to have, not a number to punish.",
  attentionViewLabel: "Show students",
  attentionView_fewest_bonuses_earned: "Fewest bonuses earned",
  attentionView_lowest_positivity: "Lowest positivity",
  attentionView_most_fined: "Most fined",
  attentionView_lowest_attendance: "Lowest attendance",
  attentionShortlist: "Shortlist of students who need attention",
  attentionEmpty_fewest_bonuses_earned: "No students in this period.",
  attentionEmpty_lowest_positivity: "No positivity data in this period.",
  attentionEmpty_most_fined: "No fines in this period.",
  attentionEmpty_lowest_attendance: "No attendance data in this period.",
  attentionShowing_one: "{{view}}: showing {{count}} student",
  attentionShowing_other: "{{view}}: showing {{count}} students",
  applyToTable: "Apply to the table below",
  allStudents: "All students",
  allStudentsQuestion:
    "How is each student doing? Sort by positivity, bonuses or attendance to see who may need support.",
  allStudentsTable: "All students table",
  noStudentsYet: "No students in your school yet.",
  searchStudent: "Search student...",
  filterByClass: "Filter by class",
  allClasses: "All Classes",
  loadingClasses: "Loading classes…",
  classesError: "Couldn't load classes.",
  noClasses: "No classes.",
  noMatchingClasses: "No matching classes.",
  searchClasses: "Search classes",
  showingAllClasses: "Showing all classes",
  showingClasses_one: "Showing {{count}} class:",
  showingClasses_other: "Showing {{count}} classes:",
  removeClass: "Remove {{name}}",
  clearAllClasses: "Clear all",
  classesSelected_one: "{{count}} selected",
  classesSelected_other: "{{count}} selected",
  applyClasses: "Apply ({{count}})",
  discardClasses: "Discard",
  cancel: "Cancel",
  removePendingClass: "Remove {{name}}, not applied yet",
  restoreClass: "Undo removing {{name}}",
  noStudentsInClasses: "No students in the selected classes.",
  noMatchesInClasses: 'No matches for "{{- match}}" in the selected classes.', // eslint-disable-line
  clearFilters: "Clear filters",
  sortedBy: "Sorted by: {{view}}",
  clearSort: "Clear sort",
  showingStudents: "Showing {{from}}–{{to}} of {{total}} students",
  column_student: "Student",
  noClass: "No class",
  classCount_one: "{{count}} class",
  classCount_other: "{{count}} classes",
  attendanceDaysNotConnected:
    "Connect the attendance integration to see attendance.",
  attendanceConnectLink:
    "<Link>Connect the attendance integration</Link> to see attendance.",
  attendanceEmailSubject: "Attendance integration for {{schoolName}}",
  attendanceEmailBody:
    "Hi ClassBank team,\r\n\r\nWe'd like to connect the attendance integration for our school.\r\n\r\nSchool: {{schoolName}}, {{schoolCity}} (ID {{schoolId}})\r\nAdmin: {{firstName}} {{lastName}} ({{email}})",
  daysAttended_one: "{{count}} day attended",
  daysAttended_other: "{{count}} days attended",
  sentTransactionsThisPeriod: "of teachers sent transactions this period",
  avgTransactionsPerTeacher: "average transactions per teacher",
  earnedBonusThisPeriod: "Earned a bonus this period",
  noBonusesThisPeriod: "did not earn a bonus this period",
  vsPriorPeriod: "vs prior period",
  trendUp: "Up",
  trendDown: "Down",
  updating: "Updating",
  classRowSummary: "{{bonuses}} bonuses, {{fines}} fines, {{amount}} earned",
  legendBonuses: "{{value}} Bonuses",
  legendFines: "{{value}} Fines",
  noChangeVsPriorPeriod: "No change vs prior period",
  nothingToCompareYet: "Not enough data to compare yet",
  pbisAbove: "You're above the goal of 80%",
  pbisBelow:
    "PBIS recommends 4-to-1, or 80%. Catch a few more good moments this week and you're there!",
  sectionError: "We couldn't load this section.",
  tryAgain: "Try again",
  downloadAsImage: "Download as image",
  downloadSectionAsImage: "Download as image ({{section}})",
  downloadAsImageError: "We couldn't create the image. Please try again.",
  classSummary: "Class Summary",
  classSummaryQuestion:
    "Which classes earned the most - and which need support?",
  classSummaryEmpty: "No bonuses, fines or earnings in this period yet.",
  classColumn: "Class",
  bonusesFinesColumn: "Bonuses · Fines",
  positivityColumn: "Positivity",
  earnedAmount: "{{amount}} earned",
  positivityTier_high: "{{value}} positivity, on track",
  positivityTier_medium: "{{value}} positivity, needs attention",
  positivityTier_low: "{{value}} positivity, at risk",
  positivityUnknown: "Positivity unknown",
  bonusesVsFines: "Top Bonuses vs Top Fines",
  bonusesVsFinesQuestion:
    "Which behaviors are we recognizing and correcting most?",
  bonusesVsFinesEmpty: "No bonuses or fines were given in this period.",
  bonusesVsFinesTable: "Bonuses and fines per period",
  period: "Period",
  partialPeriod: "{{period}} · partial period",
  partialPeriodNote: "Partial period - fewer days than the others",
  topBonuses: "Top Bonuses",
  topFines: "Top Fines",
  behaviourColumn: "Behaviour",
  countColumn: "Count",
  trendColumn: "Trend",
  behaviourTrendNew: "New",
  behaviourTrendSame: "– 0",
  priorPeriodCount: "Prior period: {{value}}",
  showOnChart: ", show on chart",
  behaviourLabel: "{{title}} ({{type}})",
  behaviourTypeBonus: "bonus",
  behaviourTypeFine: "fine",
  behaviourTable: "{{behaviour}} by period",
  bonusTrend: "Bonus trend",
  fineTrend: "Fine trend",
  inThisPeriod: "in this period",
  ofAllBonuses: "of all bonuses",
  ofAllFines: "of all fines",
  clearBehaviour: "Clear {{title}}, show all bonuses vs fines",
  chartShowsBehaviour: "Chart shows {{behaviour}}",
  chartShowsTotals: "Chart shows all bonuses vs fines",
  chartUpdating: "Updating…",
  noBonusBehaviourInPeriod: "No “{{title}}” bonuses in this period.",
  noFineBehaviourInPeriod: "No “{{title}}” fines in this period.",
  chartError: "We couldn't load this chart.",
  behaviourSelectHint: "Select a behavior to see it on the chart",
  seeAllBehaviours: "See all behaviours",
  topBonusesAndFines: "Top 30 bonuses and fines",
  seeMore: "See more",
  seeMoreCount: "See more ({{count}})",
  allBehaviours: "All behaviours",
  showingBonuses: "Showing {{from}}–{{to}} of {{total}} bonuses",
  showingFines: "Showing {{from}}–{{to}} of {{total}} fines",
  showingBonusesNoTotal: "Showing bonuses {{from}}–{{to}}",
  showingFinesNoTotal: "Showing fines {{from}}–{{to}}",
  storeItems: "Top 10 Store Items",
  storeItemsQuestion: "What are students saving for?",
  storeItemsEmpty: "No store purchases in this period.",
  storeItemRowSummary: "{{purchases}} purchases, {{amount}} spent",
  itemColumn: "Item",
  purchasesColumn: "Purchases",
  spentColumn: "Spent",
  backToTop: "Back to top",
  showAll: "Show all ({{count}})",
  showLess: "Show less",
  schoolTransactions: "School transactions",
  presets: "Presets",
  grouping: "Grouping",
  searchForStudents: "Search for students",
  searchForClasses: "Search for classes",
  class: "Class",
  resetAll: "Reset all",
  removeSelectedItem: "Remove {{name}}",
  removeSelectedFilter: "Remove {{title}} filter",
  deleteTransaction: "Delete transaction",
  teacherOptions: "Teacher options",
  rejectTeacher: "Reject teacher",
  acceptTeacher: "Accept teacher",
  studentHelper: "Student Helper",
  searchForTeachersAndStudentHelpers: "Search for teachers and student helpers",
  typeOfTransaction: "Type of transaction",
  title: "Title",
  titleIncluding: "Title including",
  clearTitleFilter: "Clear title filter",
  sender: "Sender",
  bonuses: "Bonuses",
  fines: "Fines",
  bills: "Bills",
  searchForTeachers: "Search for teachers",
  active: "Active",
  pending: "Pending",
  actions: "Actions",
  filters: "Filters",
  export: "Export",
  type: "Type",
  classAndTeachers: "Class & Teachers",
  student: "Student",
  date: "Date",
  amount: "Amount",
  noResultsMatchingFilters:
    "No results matching the selected filtering criteria.",
  attendance: "Attendance",
  stepAttendance: "Teacher takes attendance",
  stepAttendanceMeta: "Recorded in your SIS as usual",
  stepSync: "SIS syncs automatically",
  stepSyncMeta: "No extra action needed",
  stepBonus: "Students receive bonus",
  stepBonusMeta: "Credited instantly to each student",
  bonusAmount: "Bonus Amount",
  bonusAmountDescription:
    "Set the bonus amount students automatically receive when their teacher records attendance through your SIS.",
  save: "Save",
  attendanceSaved: "Attendance bonus amount saved",
  notAuthorized: "You are not authorized to perform this action",
  bonusAmountRequired: "Please enter a bonus amount",
  bonusAmountMin: "Bonus amount must be 0 or greater",
  attendanceUpsellMessage:
    "Automatic Attendance Payments are not part of your current plan. With this feature, students receive an automatic bonus when teachers take attendance through your SIS, without teachers doing anything extra. It's a simple way to reinforce strong attendance habits while giving your team better visibility into trends over time. Please reach out to your School Success Manager if you're interested in learning more!",
}
